import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Circular from '../Circular/Circular';
import PropTypes from 'prop-types';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import MaskedInput from 'react-text-mask';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { createOrder } from '../../services/orders/orders';

import CustomInputMask from "components/CustomInput/CustomInputMask.js"
import CustomInputMaskCpf from "components/CustomInput/CustomInputMaskCpf.js"

import { getSlots, getSlotsAsync } from '../../services/slots/slots'

const useStyles = theme => ({
    iconView: {
        color: "gray !important"
    },
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: 200
        }
    },
    dialog: {
        '& .MuiPaper-root': {
            margin: theme.spacing(1),
            width: 250,
            height: 200
        }
    },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    red: {
        '& label.Mui-focused': {
            color: 'red'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'red',
        }
    }
});

class NewOrder extends Component {
    constructor(props) {
        super(props);
        this.createOrder = this.createOrder.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.cleanString = this.cleanString.bind(this);
        /*this.TextMaskCustom = this.TextMaskCustom.bind(this);
        this.TextMaskCustom.propTypes = {
            inputRef: PropTypes.func.isRequired,
        };*/

        this.state = {
            order: {},
            sizes: [
                {
                    value: 'small',
                    label: 'Pequeno',
                },
                {
                    value: 'medium',
                    label: 'Médio',
                },
                {
                    value: 'large',
                    label: 'Grande',
                },
                {
                    value: 'extra-large',
                    label: 'Extra Grande',
                }
            ],
            size: 'small',
            mobile_phone: '',
            name: null,
            cpf: null,
            email: null,
            numero_pedido: null,
            collectToken: null,
            deliveryToken: null,
            label: null,
            isInventory: null,
            waiting: false,
            error: false
        }
    }

    componentDidMount() {
        console.log('component')
    }

    createOrder = () => {
        let { order } = this.state;
        console.log(order)
        createOrder(order, (code) => {
            // console.log(JSON.stringify(code));
            this.setState({ order: {}, waiting: false });
            this.props.onChange(false);
            (code.status === 200) ? this.props.setNotification(`Nova encomenda foi criada com sucesso! PIN de depósito: ${code?.data?.deliveryToken} e PIN de coleta: ${code?.data?.collectToken}.`, "success") : this.props.setNotification("Falha ao criar nova Encomenda!", "danger");
        });

    }

    handleChange = (event) => {
        console.log(event.target.id, event.target.value)
        switch (event.target.id) {
            case 'numero_pedido':
                this.setState({ numero_pedido: event.target.value })
                break;
            case 'email':
                this.setState({ email: event.target.value })
                break;
            case 'mobile_phone':
                this.setState({ mobile_phone: event.target.value })
                break;
            case 'cpf':
                this.setState({ cpf: event.target.value })
                break;
            case 'clientName':
                this.setState({ clientName: event.target.value })
                break;
            case 'collectToken':
                this.setState({ collectToken: event.target.value })
                break;
            case 'deliveryToken':
                this.setState({ deliveryToken: event.target.value })
                break;
            case 'label':
                this.setState({ label: event.target.value })
                break;
        }
    }

    handleChangeLabel = (event) => {
        this.setState({ label: event.target.value })
    }

    handleChangeSize = (event) => {
        this.setState({ size: event.target.value })
    }

    handleClickOpen = () => {
        this.props.onChange(true);
    };


    cleanString = (texto) => {
        const newString = texto.replace(/\&/g, "e");
        // console.log(newString);
        return newString;
    }

    handleCreate = () => {
        let { order, size, mobile_phone, email, numero_pedido, cpf, clientName, collectToken, deliveryToken, label } = this.state;
        let { lockerId } = this.props

        const clientNameClean = this.cleanString(clientName);

        console.log("Locker ID: ", lockerId);
        Object.assign(order, { lockerId, size, mobile_phone, email, numero_pedido, cpf, clientName: clientNameClean, collectToken, deliveryToken, label });

        if (lockerId && size && numero_pedido !== '') {
            this.setState({ order, waiting: true, error: false });
            this.createOrder();
        } else {
            this.setState({ error: true });
        }
    };

    handleClose = () => {
        this.props.onChange(false);
    };

    render() {
        const { classes } = this.props;
        console.log(this.props.locker)
        return (
            <div>
                <Dialog className={(this.state.waiting) ? classes.dialog : null}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{(this.state.waiting) ? "Criando Encomenda" : "Criar nova Encomenda"}</DialogTitle>
                    <DialogContent>
                        {(this.state.waiting) ? <div><Circular /></div> :
                            <form className={classes.root} noValidate autoComplete="off">
                                <div>
                                    <TextField className={(this.state.error && !this.state.size) ? classes.red : classes.green}
                                        id="outlined-size-input"
                                        error={(this.state.error && !this.state.size) ? true : false}
                                        select
                                        label="Tamanho"
                                        value={this.state.size}
                                        onChange={this.handleChangeSize}
                                    >
                                        {this.state.sizes.map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <FormControl className={(this.state.error && !this.state.numero_pedido) ? classes.red : classes.green}>
                                        <InputLabel htmlFor="numero_pedido">Número pedido</InputLabel>
                                        <Input
                                            error={(this.state.error && !this.state.numero_pedido) ? true : false}
                                            value={this.state.numero_pedido}
                                            onChange={this.handleChange}
                                            id="numero_pedido"
                                        />
                                    </FormControl>
                                    <FormControl className={(this.state.error && (!this.state.clientName || this.state.clientName === '')) ? classes.red : classes.green}>
                                        <InputLabel htmlFor="clientName">Nome Cliente</InputLabel>
                                        <Input
                                            error={(this.state.error && (!this.state.clientName || this.state.clientName === '')) ? true : false}
                                            value={this.state.clientName}
                                            onChange={this.handleChange}
                                            id="clientName"
                                        />
                                    </FormControl>
                                    <FormControl className={(this.state.error && (!this.state.mobile_phone || this.state.mobile_phone === '')) ? classes.red : classes.green}>
                                        <CustomInputMask
                                            labelText="Celular"
                                            id="mobile_phone"
                                            value={this.state.mobile_phone}

                                            inputProps={{
                                                value: this.state.mobile_phone,
                                                onChange: this.handleChange,
                                            }}
                                            formControlProps={{
                                                fullWidth: true,
                                                className: this.props.classes.inputMargin
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl className={(this.state.error && !this.state.email) ? classes.red : classes.green}>
                                        <InputLabel htmlFor="email">Email</InputLabel>
                                        <Input
                                            error={(this.state.error && !this.state.email) ? true : false}
                                            value={this.state.email}
                                            onChange={this.handleChange}
                                            id="email"
                                        />
                                    </FormControl>
                                    <FormControl className={(this.state.error && !this.state.cpf) ? classes.red : classes.green}>
                                        <InputLabel htmlFor="cpf">Documento</InputLabel>
                                        <Input
                                            error={(this.state.error && !this.state.cpf) ? true : false}
                                            value={this.state.cpf}
                                            onChange={this.handleChange}
                                            id="cpf"
                                        />
                                    </FormControl>
                                    {(this.props.locker.hasInventory == true) ? <>
                                        <FormControl className={(this.state.error && !this.state.deliveryToken) ? classes.red : classes.green}>
                                            <InputLabel htmlFor="deliveryToken">Token entrega</InputLabel>
                                            <Input
                                                error={(this.state.error && !this.state.deliveryToken) ? true : false}
                                                value={this.state.deliveryToken}
                                                onChange={this.handleChange}
                                                id="deliveryToken"
                                            />
                                        </FormControl>
                                        <FormControl className={(this.state.error && (!this.state.collectToken || this.state.collectToken === '')) ? classes.red : classes.green}>
                                            <InputLabel htmlFor="collectToken">Token coleta</InputLabel>
                                            <Input
                                                error={(this.state.error && (!this.state.collectToken || this.state.collectToken === '')) ? true : false}
                                                value={this.state.collectToken}
                                                onChange={this.handleChange}
                                                id="collectToken"
                                            />
                                        </FormControl>
                                        <TextField className={(this.state.error && !this.state.label) ? classes.red : classes.green}
                                            id="label"
                                            error={(this.state.error && !this.state.label) ? true : false}
                                            select
                                            label="Porta"
                                            value={this.state.label}
                                            onChange={this.handleChangeLabel}
                                        >
                                            {this.props.slots.map(option => (
                                                <MenuItem key={option.id} value={option.label}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </> : <></>
                                    }
                                </div>
                            </form>}
                    </DialogContent>
                    <DialogActions>
                        {(this.state.waiting) ? null :
                            <div><Button onClick={this.handleClose} color="default">
                                Cancelar
                            </Button>
                                <Button onClick={this.handleCreate} color="primary" autoFocus>
                                    Criar
                                </Button></div>}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(useStyles)(NewOrder);